(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-business-contact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-business-contact')) {
  customElements.define('mp-business-contact', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const summary = this.querySelector('[data-selection-summary]');
      const initial = summary?.textContent;
      const choices = [...this.querySelectorAll('[data-book-choice]')];
      const count = this.querySelector('[data-selection-count]');
      const refresh = () => {
        const selected = choices.filter(input => input.checked).map(input => input.value);
        if (summary) summary.textContent = selected.length ? `${this.dataset.selectedLabel} ${selected.join(' · ')}` : initial;
        if (count) count.textContent = count.dataset.countLabel.replace('__COUNT__', String(selected.length));
      };
      const track = this.querySelector('[data-book-track]');
      const previous = this.querySelector('[data-scroll-prev]');
      const next = this.querySelector('[data-scroll-next]');
      const controls = this.querySelector('[data-scroll-controls]');
      if (track && previous && next && controls) {
        controls.hidden = false;
        const sync = () => {
          previous.disabled = track.scrollLeft <= 5;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
        };
        const move = direction => {
          const card = track.querySelector('.mp-business-book-card');
          const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
          track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', sync, { signal, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.resizeObserver = new ResizeObserver(sync);
        this.resizeObserver.observe(track);
        sync();
      }
      choices.forEach(input => input.addEventListener('change', refresh, { signal }));
      window.addEventListener('pageshow', refresh, { signal });
      refresh();
      const campaign = this.querySelector('[data-campaign]');
      if (campaign) {
        const params = new URLSearchParams(location.search);
        const values = ['utm_source', 'utm_medium', 'utm_campaign'].filter(key => params.has(key)).map(key => `${key}: ${params.get(key).slice(0,200)}`);
        if (values.length) { campaign.value = values.join(' | '); campaign.disabled = false; }
      }
      const notice = this.querySelector('[data-form-success], [data-form-error]');
      if (notice) {
        notice.focus({ preventScroll: true });
        notice.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-on-the-road"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-road-gallery')) {
  customElements.define('mp-road-gallery', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready = true;
      this.links = [...this.querySelectorAll('[data-road-image]')];
      this.dialog = this.querySelector('dialog');
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.links.forEach((link,i) => link.addEventListener('click', e => { e.preventDefault(); this.trigger = link; this.display(i); this.dialog.showModal(); this.oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; },opts));
      this.querySelector('[data-road-close]').addEventListener('click', () => this.dialog.close(), opts);
      this.querySelector('[data-road-previous]').addEventListener('click', () => this.display(this.index - 1), opts);
      this.querySelector('[data-road-next]').addEventListener('click', () => this.display(this.index + 1), opts);
      this.dialog.addEventListener('keydown', e => { if(e.key === 'ArrowRight') {e.preventDefault();this.display(this.index + 1);} if(e.key === 'ArrowLeft') {e.preventDefault();this.display(this.index - 1);} },opts);
      this.dialog.addEventListener('click', e => { if(e.target === this.dialog) this.dialog.close(); },opts);
      this.dialog.addEventListener('close', () => { document.body.style.overflow = this.oldOverflow || ''; this.trigger?.focus(); },opts);
    }
    display(i) {this.index = (i + this.links.length) % this.links.length; const link = this.links[this.index]; const img = this.querySelector('[data-road-full]'); img.src = link.href; img.alt = link.querySelector('img').alt; this.querySelector('[data-road-count]').textContent = `${this.index + 1} / ${this.links.length}`; }
    disconnectedCallback() { if(this.dialog?.open) this.dialog.close(); this.abort?.abort(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-pamp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mp-pamp')) {
  customElements.define('mp-pamp', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelectorAll('[data-judge]').forEach(card => {
        const front = card.querySelector('[data-front]');
        const back = card.querySelector('[data-back]');
        const open = card.querySelector('[data-flip]');
        const close = card.querySelector('[data-close]');
        open.hidden = false; close.hidden = false;
        back.inert = true; back.setAttribute('aria-hidden', 'true');
        const flip = active => {
          card.classList.toggle('is-flipped', active);
          front.inert = active; back.inert = !active;
          front.setAttribute('aria-hidden', String(active));
          back.setAttribute('aria-hidden', String(!active));
          open.setAttribute('aria-expanded', String(active));
          (active ? close : open).focus({preventScroll:true});
        };
        open.addEventListener('click', () => flip(true));
        close.addEventListener('click', () => flip(false));
        card.addEventListener('keydown', event => {
          if (event.key === 'Escape' && card.classList.contains('is-flipped')) { event.preventDefault(); flip(false); }
        });
      });
      this.classList.add('is-enhanced');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
if(!customElements.get('mp-email-signup')){customElements.define('mp-email-signup',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.panel=this.querySelector('.mp-signup-panel');this.teaser=this.querySelector('.mp-signup-teaser');this.launch=this.querySelector('[data-launch]');this.key='mp-newsletter-dismissed-v1';this.filled='mp-newsletter-subscribed-v1';this.manual=false;this.read=k=>{try{return localStorage.getItem(k)}catch(e){return null}};this.store=(k,v)=>{try{localStorage.setItem(k,v)}catch(e){}};this.suppressed=Date.now()-Number(this.read(this.key)||0)<604800000;this.show=manual=>{if(this.hasAttribute('data-blocked'))return;this.manual=manual;this.panel.hidden=false;this.teaser.hidden=true;this.launch.setAttribute('aria-expanded','true');if(manual)this.querySelector('input[type=email]')?.focus()};this.close=()=>{this.panel.hidden=true;this.teaser.hidden=!!this.read(this.filled);this.launch.setAttribute('aria-expanded','false');this.store(this.key,String(Date.now()));if(this.manual&&!this.teaser.hidden)this.launch.focus()};this.launch.addEventListener('click',()=>this.show(true));this.querySelector('[data-close]').addEventListener('click',this.close);this.querySelector('[data-dismiss]').addEventListener('click',()=>{this.teaser.hidden=true;this.store(this.key,String(Date.now()))});this.keyHandler=e=>{if(e.key==='Escape'&&!this.panel.hidden)this.close()};document.addEventListener('keydown',this.keyHandler);this.check=()=>{const blocked=!!document.querySelector('cart-drawer[open],search-drawer[open],navigation-drawer[open],dialog[open],[aria-modal="true"][open]');this.toggleAttribute('data-blocked',blocked);if(blocked&&!this.panel.hidden){this.panel.hidden=true;this.launch.setAttribute('aria-expanded','false');this.teaser.hidden=!!this.read(this.filled);this.store(this.key,String(Date.now()))}};this.observer=new MutationObserver(this.check);this.observer.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});this.check();if(this.querySelector('[data-success]')){this.store(this.filled,'true');this.show(false);return}if(this.querySelector('[data-errors]')){this.show(false);return}if(this.hasAttribute('data-editor')){this.show(false);return}if(this.read(this.filled)||this.read('theme:popup-filled'))return;this.teaserTimer=setTimeout(()=>{if(this.panel.hidden&&!this.suppressed)this.teaser.hidden=false},8000);this.openTimer=setTimeout(()=>{if(matchMedia('(min-width:700px)').matches&&!this.suppressed&&!this.read(this.filled)&&Date.now()-Number(this.read(this.key)||0)>=604800000&&document.visibilityState==='visible')this.show(false)},Math.max(20,Number(this.dataset.delay)||20)*1000)}
disconnectedCallback(){clearTimeout(this.teaserTimer);clearTimeout(this.openTimer);this.observer?.disconnect();document.removeEventListener('keydown',this.keyHandler)}
})}

  } catch(e) { console.error(e); }
})();
})();
